import pageURL from '../utils/pageUrls';

export const LOCAL_KEYS = Object.freeze({
  Lang: 'SCP_LANG',
  User: 'SCP_USER',
  Token: 'SCP_TOKEN'
});

export const FileSettings = Object.freeze({
  CompressionQuality: 0.6,
  CompressionMaxLength: 2,
  Height: 2400,
  Length: 2400
});

export const SORT_TYPE = Object.freeze({
  '-1': 'Desc',
  1: 'Asc'
});

export const MODULE_CODES_AND_PATH = [
  { code: 'PIF', to: pageURL.pif, key: 'pif', icon: 'pi pi-file' },
  {
    code: 'CURRENT_ACCOUNT_OPENING',
    to: pageURL.currentAccountOpeningDashboard,
    key: 'suppliersOpening',
    icon: 'pi pi-user-plus'
  },
  { code: 'MODULE', to: pageURL.moduleManagement, key: 'moduleManagement', icon: 'pi pi-cog' },
  { code: 'USER', to: pageURL.userManagement, key: 'userManagement', icon: 'pi pi-user' },
  {
    code: 'CARI',
    to: pageURL.supplierAccountManagement,
    key: 'supplierAccountManagement',
    icon: 'pi pi-users'
  },
  {
    code: 'KKDIK',
    to: pageURL.kkdikDashboard,
    key: 'kkdik.productManagement',
    icon: 'pi pi-box'
  },
  {
    code: 'ECOM',
    to: pageURL.productDetailInformationManagement,
    key: 'ecom',
    icon: 'pi pi-shopping-bag'
  },
  {
    code: 'ROLE',
    to: pageURL.roleManagement,
    key: 'roleManagement',
    icon: 'pi pi-shield'
  },
  {
    code: 'CONTRACT',
    to: pageURL.contractManagement,
    key: 'contractManagement',
    icon: 'pi pi-file-edit'
  },
  {
    code: 'CATEGORY',
    to: pageURL.categoryManagement,
    key: 'categoryManagement',
    icon: 'pi pi-sitemap'
  },
  {
    code: 'PSM',
    to: pageURL.promotion,
    key: 'promotion',
    icon: 'pi pi-tags'
  },
  {
    code: 'TEST_AUTOMATION',
    to: '/test-automation',
    key: 'testAutomation',
    icon: 'pi pi-microchip-ai'
  }
];

export const ROLES = Object.freeze({
  SYS_ADMIN: 'SYS_ADMIN',
  KKDIK_WATSONS_ADMIN: 'KKDIK_WATSONS_ADMIN',
  KKDIK_SUPPLIER_ADMIN: 'KKDIK_SUPPLIER_ADMIN',
  KKDIK_WATSONS_USER: 'KKDIK_WATSONS_USER',
  KKDIK_SUPPLIER_USER: 'KKDIK_SUPPLIER_USER',
  ECOM_WATSONS_ADMIN: 'ECOM_WATSONS_ADMIN',
  ECOM_WATSONS_USER: 'ECOM_WATSONS_USER'
});

export const PROFILE_TYPE = Object.freeze({
  Watsons: 1,
  Supplier: 2
});

export const PRODUCT_BARCODE_STATUS = Object.freeze({
  Draft: 0,
  NotSent: 1,
  Sent: 2,
  Expired: 3,
  Rejected: 4
});

export const PRODUCT_BARCODE_FILE_STATUS = Object.freeze({
  Pending: 0,
  NotAvailiable: 1,
  Uploaded: 2,
  Confirmed: 3,
  Rejected: 4,
  WaitingApproval: 5
});

export const SUPPLIER_PIF_STATUS = Object.freeze({
  Waiting: 0,
  Continued: 1,
  Uploaded: 2,
  Sent: 3,
  ReEvaluation: 4
});

export const COUNSELLOR_PIF_STATUS = Object.freeze({
  None: 0,
  PendingEvaluation: 1,
  EvaluationProcessContinuing: 2,
  Confirmed: 3,
  Rejected: 4
});

export const ProductBarcodeFileType = Object.freeze({
  InnerPackaging: 0,
  OuterPackaging: 1,
  TurkishLabeling: 2,
  ProductPicture: 3,
  ProductionMethod: 4,
  GmpCompliance: 5,
  Formulation: 6,
  IfraCertificateOfConformity: 7,
  AllergenReport: 8,
  ParfumAromaCoaTds: 9,
  ParfumAromaMsds: 10,
  RawMaterialCoaTds: 11,
  RawMaterialMsds: 12,
  RawMaterialOther: 13,
  FinishedProductTds: 14,
  FinishedProductMsds: 15,
  MicrobiologicallyTest: 16,
  ChallengeTest: 17,
  StabilityTest: 18,
  PackagingTds: 19,
  PackagingMsds: 20,
  Impurities: 21,
  ProofOfClaims: 22,
  SafetyAssessor: 23,
  SafetyAssessmentReport: 24,
  Other: 25,
  AhaBhaConcentrationDeclaration: 26
});

export const ApplicableStatus = Object.freeze({
  NotApplicable: 0,
  Applicable: 1
});

export const NewUploadOrDeclarationStatus = Object.freeze({
  None: 0,
  Declaration: 1,
  NewUpload: 2
});

export const DOCUMENT_STATUS = Object.freeze({
  Created: 1,
  DocumentsRequested: 2,
  DocumentsShared: 3,
  MissingOrIncorrectDocumentsPending: 4,
  DataEntryUnderReview: 5,
  ManagerHeadAuditReview: 6,
  Approved: 7,
  Rejected: 8,
  Closed: 9,
  Completed: 10
});

export const CURRENT_ACCOUNT_APPROVAL_STATUS = Object.freeze({
  None: 0,
  Waiting: 1,
  Approval: 2,
  Rejected: 3
});

export const CURRENT_ACCOUNT_DOCUMENT_STATUS = Object.freeze({
  Waiting: 0,
  WaitingApproval: 1,
  Approval: 2,
  Rejected: 3,
  Uploaded: 4
});

export const DEPARTMENTS = Object.freeze({
  None: 0,
  DataEntry: 1,
  Audit: 2,
  Category: 3
});

export const CURRENT_ACCOUNT_USER_TYPE = Object.freeze({
  Created: 1,
  DataEntry: 2,
  Audit: 3,
  Manager: 4,
  HeadRepresentative: 5,
  Company: 6,
  ManagerAndHead: 7
});

export const PRODUCT_STATUS = Object.freeze({
  AC: 'AC',
  PA: 'PA',
  DL: 'DL',
  DC1: 'DC1',
  DC2: 'DC2'
});

export const CHEMICAL_CONTENT_ENTRY_STATUS = Object.freeze({
  0: 'general.chemicalContentStatus.notStarted',
  1: 'general.chemicalContentStatus.inProgress',
  2: 'general.chemicalContentStatus.completed'
});

export const ECOM_PRODUCT_STATUS = Object.freeze({
  0: 'ecom.productStatus.notStarted',
  1: 'ecom.productStatus.inProgress',
  2: 'ecom.productStatus.completed'
});

export const CONTRACT_STATUS = Object.freeze({
  ALL_EXCEPT_CLOSED: 0,
  CREATED: 1,
  MANAGER_CONTROL: 2,
  INCORRECT_INFO: 3,
  SENT_TO_SUPPLIER: 4,
  COMMERCIAL_UPLOADED: 5,
  SMS_COMPLETED: 6,
  ACTIVE: 7,
  CLOSED: 8
});

export const CONTRACT_STATUS_LABELS = Object.freeze({
  [CONTRACT_STATUS.ALL_EXCEPT_CLOSED]: 'contractManagement.filters.allExceptClosed',
  [CONTRACT_STATUS.CREATED]: 'contractManagement.status.created',
  [CONTRACT_STATUS.MANAGER_CONTROL]: 'contractManagement.status.managerControl',
  [CONTRACT_STATUS.INCORRECT_INFO]: 'contractManagement.status.incorrectInfo',
  [CONTRACT_STATUS.SENT_TO_SUPPLIER]: 'contractManagement.status.sentToSupplier',
  [CONTRACT_STATUS.COMMERCIAL_UPLOADED]: 'contractManagement.status.commercialUploaded',
  [CONTRACT_STATUS.SMS_COMPLETED]: 'contractManagement.status.smsCompleted',
  [CONTRACT_STATUS.ACTIVE]: 'contractManagement.status.active',
  [CONTRACT_STATUS.CLOSED]: 'contractManagement.status.closed'
});

export const CONTRACT_USER_PERMISSIONS = Object.freeze({
  CMM_CONTRACT_LIST: 'CMM_CONTRACT_LIST',
  CMM_CONTRACT_CREATE: 'CMM_CONTRACT_CREATE',
  CMM_CONTRACT_UPDATE: 'CMM_CONTRACT_UPDATE',
  CMM_CONTRACT_GET_ATTACHMENT: 'CMM_CONTRACT_GET_ATTACHMENT',
  CMM_CONTRACT_ADD_ATTACHMENT: 'CMM_CONTRACT_ADD_ATTACHMENT',
  CMM_CONTRACT_MANAGER_APPROVAL: 'CMM_CONTRACT_UPDATE_STATUS_SUBMIT_MANAGER_FOR_APPROVAL',
  CMM_CONTRACT_HISTORY: 'CMM_CONTRACT_HISTORY',
  CMM_CONTRACT_MARK_INCOMPLETE: 'CMM_CONTRACT_UPDATE_STATUS_INVALID_INFORMATION',
  CMM_CONTRACT_SEND_SUPPLIER: 'CMM_CONTRACT_UPDATE_STATUS_SEND_SUPPLIER',
  CMM_CONTRACT_UPLOAD_SCANNED: 'CMM_CONTRACT_UPLOAD_SCANNED',
  CMM_CONTRACT_DOWNLOAD_SCANNED: 'CMM_CONTRACT_DOWNLOAD_SCANNED',
  CMM_CONTRACT_SMS_ENTRY: 'CMM_CONTRACT_UPDATE_STATUS_SMS_ENTRY_DONE',
  CMM_CONTRACT_MARK_ACTIVE: 'CMM_CONTRACT_UPDATE_STATUS_ACTIVE',
  CMM_CONTRACT_MARK_CLOSED: 'CMM_CONTRACT_UPDATE_STATUS_CLOSED',
  CMM_CONTRACT_COMMENT: 'CMM_CONTRACT_COMMENT',
  CMM_CONTRACT_DELETE: 'CMM_CONTRACT_DELETE',
  CMM_CONTRACT_GET: 'CMM_CONTRACT_GET'
});
